export enum actionTypes {
    SET_DATA = 'LOGIN_HISTORY:SET_DATA',
    UPDATE_HISTORY = 'LOGIN_HISTORY:UPDATE_HISTORY',
    LOAD_NEXT_PAGE = 'LOGIN_HISTORY:LOAD_NEXT_PAGE'
}
